import React from 'react';
import {HomepageSection, HomepageSectionHeader2} from '../Homepage';
import ReactHighcharts from 'react-highcharts';
import PropTypes from 'prop-types';
import {process_country} from "../helper";

class Age18 extends React.Component {
  render() {
    // Array of countries, each holding the count for either kids OR adults
    const age_18 = this.props.data;
    const extData = process_country();
    let co_map = {};
    let u18 = [];
    let o18 = [];

    // Loop through countries and create a map holding both of them
    age_18.map(a => {
      const minor = (a.geq_18) ? 0:1;
      const ageType = (a.geq_18) ? "over_18":"under_18";
      if (!(a.country in co_map)) {co_map[a.country] = [0,0];}

      co_map[a.country][minor] = a.n;

      // map external centers
      if (a.iso2 in extData) {
        co_map[a.country][minor] += extData[a.iso2]["age_class"][ageType];
      }
    });

    for (let x in co_map){
        u18.push(co_map[x][1]);
        o18.push(co_map[x][0])
    }

    const N = _.sumBy(age_18, 'n');

    const configAge18 = {
      chart: {
        type: 'column'
      },
      exporting: { enabled: false },
      title: {
        text: 'Patients by age classes'
      },
      subtitle: {
        text: `N = ${N}`
      },
      xAxis: {
        categories: _.uniqBy(age_18, 'iso2').map(elem => (elem.country))
      },
      yAxis: {
        min: 0,
        title: {
          text: '% of patients'
        }
      },
      tooltip: {
        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        shared: true
      },
      plotOptions: {
        column: {
          stacking: 'percent'
        },
        series: {
          dataLabels: {
            enabled: true
          }
        }
      },
      series: [{
        name: 'age >= 18',
        data: o18,
      }, {
        name: 'age < 18',
        data: u18,
      }]
    };

    console.log(configAge18);

    return (
      <HomepageSection>
        <HomepageSectionHeader2>
          <h2><span>{'Patients by age classes '}</span></h2>
        </HomepageSectionHeader2>
        <div className='text-center' style={{marginTop: 25, marginBottom: 25}}>
          <ReactHighcharts config={configAge18}/>
        </div>
        <p>
          We calculate the age of a patient by computing the distance between <b>date of last news</b> minus <b>date of birth</b>.
        </p>
      </HomepageSection>
    );
  }
}

Age18.propTypes = {
  data: PropTypes.array.isRequired
};

export default Age18;


// WEBPACK FOOTER //
// ./src/views/Pages/Homepage/Sections/Age18.js